import { render } from "./CreateInterimReferralRow.vue?vue&type=template&id=322dfe16&ts=true"
import script from "./CreateInterimReferralRow.ts?vue&type=script&lang=ts&external"
export * from "./CreateInterimReferralRow.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__